
{
  "title": "About WhatsGood HK",
  "subtitle": "A Hong Kong service directory built to help expats find reputable providers faster",
  "mission": {
    "title": "Our Mission",
    "description": "WhatsGood HK helps expats in Hong Kong quickly find reputable local service providers, compare useful details at a glance, and contact them directly with more confidence."
  },
  "whatWeOffer": {
    "title": "What We Offer",
    "verified": {
      "title": "Useful provider profiles",
      "description": "Browse providers by service, area, and profile details so it is easier to decide who is relevant before you reach out."
    },
    "directContact": {
      "title": "Direct Contact",
      "description": "Customers contact providers directly through WhatsApp. WhatsGood HK does not take a commission on enquiries."
    },
    "reviews": {
      "title": "Trust cues that help you decide",
      "description": "Reviews, verification, and clearer provider information help expats understand which providers other customers have used and trusted where that data is available."
    }
  },
  "whyChoose": {
    "title": "Why Choose WhatsGood HK?",
    "local": {
      "title": "Helpful & Localised",
      "description": "The directory is tailored to Hong Kong service discovery, local coverage areas, and the way people here actually reach out to providers on WhatsApp."
    },
    "expat": {
      "title": "Built for expats who need answers quickly",
      "description": "WhatsGood HK is designed to reduce guesswork for expats by making it easier to find relevant providers, compare options fast, and move straight to contact."
    },
    "transparent": {
      "title": "Transparent",
      "description": "You browse for free, contact providers directly, and see trust signals only where there is real information to support them."
    }
  }
}
